import React from 'react';
import { MdLogout } from 'react-icons/md';
import {
  HeaderLink,
  ProfileContainer,
  ProfileIcon,
  ProfileSubContainer,
  ToggleMenuContainer,
  User
} from './styles';
import { useHover } from './useHover';
import { useUser } from './useUser';

export const Profile: React.FC = () => {
  const { hide, onHover } = useHover();
  const user = useUser();

  return (
    <ProfileContainer>
      <ProfileIcon onMouseEnter={onHover} />
      {hide && (
        <ProfileSubContainer onMouseLeave={onHover}>
          <ToggleMenuContainer>
            <User>{user?.username}</User>
            <HeaderLink to="/signin">
              <MdLogout size={18} />
              Odhlášení
            </HeaderLink>
          </ToggleMenuContainer>
        </ProfileSubContainer>
      )}
    </ProfileContainer>
  );
};
